import React, { useContext } from "react";
import Receipt from "./Receipt";
import Invoice from "./Invoice";
import Statement from "./Statement";
import ClientInformation from "./ClientInformation";
import CreatedReceipts from "./CreatedReceipts";
import Labels from "./Labels";
import { Page, Document, PDFViewer } from "@react-pdf/renderer";
import AppContext from "AppContext";
import currencies from "utils/static/currencies";

function Report({ reportProps, reportType }) {
    const { configurations } = useContext(AppContext);
    const currencyConfig = configurations.find((config) => config.id === "general_currency");
    const currencyIsoCode = currencyConfig?.value;
    const currency = currencies.find((c) => c.isoCode === currencyIsoCode);

    if (reportType === "invoice") {
        return (
            <PDFViewer width="100%" height="900px">
                <Invoice {...reportProps} currency={currency} />
            </PDFViewer>
        );
    }

    if (reportType === "receipt") {
        return (
            <PDFViewer width="100%" height="900px">
                <Receipt {...reportProps} currency={currency} />
            </PDFViewer>
        );
    }

    if (reportType === "statement") {
        return (
            <PDFViewer width="100%" height="900px">
                <Statement {...reportProps} currency={currency} />
            </PDFViewer>
        );
    }

    if (reportType === "client-information") {
        return (
            <PDFViewer width="100%" height="900px">
                <ClientInformation {...reportProps} />
            </PDFViewer>
        );
    }

    if (reportType === "created-receipts") {
        return (
            <PDFViewer width="100%" height="900px">
                <CreatedReceipts {...reportProps} currency={currency} />
            </PDFViewer>
        );
    }

    if (reportType === "created-receipts-annulment") {
        return (
            <PDFViewer width="100%" height="900px">
                <CreatedReceipts {...reportProps} currency={currency} />
            </PDFViewer>
        );
    }

    if (reportType === "labels") {
        return (
            <PDFViewer width="100%" height="900px">
                <Labels {...reportProps} />
            </PDFViewer>
        );
    }

    return (
        <PDFViewer width="100%" height="900px">
            <Document>
                <Page size="A4"></Page>
            </Document>
        </PDFViewer>
    );
}

export default Report;
